import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react';
import messages from 'messages';
import {
  ActionButton,
  Panel,
  PanelHeader,
  PanelTitle,
  PanelTitleButton,
  PanelTitleButtonsGroup,
  PanelTitleWrapper
} from 'components/panel';
import {
  ROUTE_EXERCISES,
  ROUTE_EXERCISES_PROGRAMS_ENTITY,
  ROUTE_EXERCISES_PROGRAMS_ENTITY_PROGRAM,
  ROUTE_EXERCISES_PROGRAMS_ENTITY_PROGRAM_EDIT_EXERCISES
} from 'routes/RouteList';
import { Breadcrumb, Breadcrumbs } from 'components/breadcrumbs';
import AddProgramModal from './AddProgramModal';
import Loader from 'components/loader/Loader';
import ProgramsList from 'containers/partials/lists/ProgramsList';
import {
  generatePath,
  useHistory,
  useParams,
  useRouteMatch
} from 'react-router-dom';
import usePrograms from 'hooks/queries/usePrograms';
import { useStore } from 'stores/Store';
import AddButton from 'containers/partials/buttons/AddButton';
import ContextMenu from 'components/menu/ContextMenu';
import ContextMenuWrapper from 'components/menu/ContextMenuWrapper';
import { useAbility } from '@casl/react';
import { AbilityContext } from 'Can';

const Programs = () => {
  const { entityId } = useParams();
  const { push } = useHistory();
  const ability = useAbility(AbilityContext);
  const active = useRouteMatch(ROUTE_EXERCISES_PROGRAMS_ENTITY);

  const [modalData, setModalData] = useState(null);

  const { fetchPrograms, filterPrograms, loading } = usePrograms(entityId);
  const programs = useStore(state => state.programs);

  useEffect(() => {
    fetchPrograms();
  }, []);

  const onSearch = e => {
    filterPrograms({ search: e.target.value });
  };

  const onClickHandler = program => {
    push(
      generatePath(ROUTE_EXERCISES_PROGRAMS_ENTITY_PROGRAM, {
        entityId,
        programId: program.id
      })
    );
  };

  return (
    <Panel active={active.isExact}>
      <PanelHeader>
        <Breadcrumbs>
          <Breadcrumb to={ROUTE_EXERCISES}>
            <FormattedMessage {...messages.breadcrumbOverview} />
          </Breadcrumb>
        </Breadcrumbs>
        <PanelTitleWrapper>
          <PanelTitle>
            <FormattedMessage {...messages.programs} />
          </PanelTitle>
        </PanelTitleWrapper>
        <PanelTitleButtonsGroup>
          {ability.can('create', 'Programs') && (
            <ActionButton>
              <AddButton
                onClick={() => setModalData(true)}
                label={
                  <FormattedMessage {...messages.exercisesAddProgramButton} />
                }
              />
            </ActionButton>
          )}
          <ContextMenuWrapper trigger={<PanelTitleButton />}>
            <ContextMenu />
          </ContextMenuWrapper>
        </PanelTitleButtonsGroup>
      </PanelHeader>
      {loading && <Loader />}

      <ProgramsList
        entityId={entityId}
        programs={programs}
        onClick={program => onClickHandler(program)}
        onSearch={onSearch}
      />

      {modalData && (
        <AddProgramModal
          entityId={entityId}
          destiny={{
            path: ROUTE_EXERCISES_PROGRAMS_ENTITY_PROGRAM_EDIT_EXERCISES,
            variables: {}
          }}
          program={{
            entityId,
            title: '',
            startdate: '',
            duration: '',
            description: '',
            exerciseIds: [],
            exercises: []
          }}
          onClose={() => setModalData(null)}
          onComplete={() => {
            setModalData(null);
            fetchPrograms({ fetchPolicy: 'network-only' });
          }}
        />
      )}
    </Panel>
  );
};

export default observer(Programs);
